module.exports = __webpack_public_path__ + "static/img/section_2_bg.99c90a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.0/mobile/section_2_bg.jpg
// module id = RRys
// module chunks = 0